import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Utility } from '../../core/utils/utility';
import { Observable, Subject, concatMap, tap } from 'rxjs';
import { AuthService } from '../../auth/_services/auth.service';
import { SignalrService } from './signalr.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectRequestService {

  pendingCount = 0;
  pendingCount$: Subject<number> = new Subject<number>();
  apiUrl: string = `${environment.apiUrl}/connectrequest`;

  constructor(private http: HttpClient, private authService: AuthService, signalR: SignalrService) {
    signalR.connectRequestSent.subscribe(x => {
      this.pendingCount++;
      this.pendingCount$.next(this.pendingCount);
    })

    if (authService.isAdminOrOperator) {
      this.getStats().subscribe();
    }
    else if (authService.isTenantAdminOrOperator) {
      this.getStatsForTenant().subscribe();
    }
  }

  getById(userId: any): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/${userId}`);
  }

  getForEndUser(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}/mine`, { params: params });
  }


  getForTenant(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}/tenant`, { params: params });
  }

  getStatsForTenant() {
    return this.http.get<any>(`${this.apiUrl}/tenant/stats`)
      .pipe(
        tap(x => {
          this.pendingCount = x.pending;
          this.pendingCount$.next(x.pending);
        })
      );
  }

  getForSuperUser(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http.get<any>(`${this.apiUrl}`, { params: params });
  }

  getStats() {
    return this.http.get<any>(`${this.apiUrl}/stats`)
      .pipe(
        tap(x => {
          this.pendingCount = x.pending;
          this.pendingCount$.next(x.pending);
        })
      );
  }

  changeStatus(id: string | null, approved: boolean) {
    if (approved)
      return this.http.patch(`${this.apiUrl}/approve/${id}`, {})
        .pipe(
          concatMap(_ => {
            if (this.authService.isAdminOrOperator)
              return this.getStats();
            else
              return this.getStatsForTenant();
          })
        );

    return this.http.patch(`${this.apiUrl}/reject/${id}`, {})
      .pipe(
        concatMap(_ => {
          if (this.authService.isAdminOrOperator)
            return this.getStats();
          else
            return this.getStatsForTenant();
        })
      );
  }

  sendRequest(value: any) {
    return this.http.post(`${this.apiUrl}`, value);
  }

  connect(connectRequestId: number, senderId: string, toIds: any[]) {
    return this.http.post(`${this.apiUrl}/connect`, { senderId, toIds });
  }
}
